// tabbed-page.component.ts
import {Directive, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTabChangeEvent} from '@angular/material/tabs';

@Directive()
export abstract class TabbedPageComponent {
    protected route = inject(ActivatedRoute);
    protected router = inject(Router);

    // Default to the second tab (index 1) so that the first header tab is skipped.
    selectedIndex: number = 1;
    // Name of the query parameter used to store the tab index; override if needed.
    queryParamName: string = 'tab';

    OnInit(): void {
        // Use the snapshot to set the initial selected tab
        const indexParam = this.route.snapshot.queryParamMap.get(this.queryParamName);
        const parsedIndex = parseInt(indexParam || '', 10);
        this.selectedIndex = !isNaN(parsedIndex) && parsedIndex >= 0 ? parsedIndex : 1;

        // Subscribe to any changes in the query parameters.
        this.route.queryParams.subscribe(params => {
            const paramValue = parseInt(params[this.queryParamName] || '', 10);
            this.selectedIndex = !isNaN(paramValue) && paramValue >= 0 ? paramValue : 1;
        });
    }

    onTabChange(event: MatTabChangeEvent): void {
        this.selectedIndex = event.index;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { [this.queryParamName]: event.index },
            queryParamsHandling: 'merge'
        });
    }
}
